<div class="dashboardWidget medium" #dashboardRecallsWidget>
    <div class="dashboardWrapper recallsWidget" *ngIf="viewModel$ | async as viewModel">
      <div class="recallsWidgetWrapper">
        <app-one-number [loading]="viewModel.loading"
                        [value]="viewModel.totalRecallsCount"
                        reportType="recalls"></app-one-number>
      </div>
    </div>
</div>
